export default __webpack_public_path__ + "static/media/childDevelopment-blob1.1c82f605.svg";